import { render, staticRenderFns } from "./ViceBannerList.vue?vue&type=template&id=ede8882c&scoped=true&"
import script from "./ViceBannerList.vue?vue&type=script&lang=ts&"
export * from "./ViceBannerList.vue?vue&type=script&lang=ts&"
import style0 from "./ViceBannerList.vue?vue&type=style&index=0&id=ede8882c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede8882c",
  null
  
)

export default component.exports